import { ICustomErrorProps } from '@ms/utilities-error/lib/CustomError';
import { ApiError } from '@ms/utilities-error/lib/ApiError';

/**
 * @public
 */
export interface ITimeoutErrorProps extends ICustomErrorProps {
  timeout: number;
}

/**
 * Error to be thrown when an operation times out.
 * @public
 */
export class TimeoutError extends ApiError {
  public readonly timeout: number;

  constructor({
    timeout,
    ...props
  }: ITimeoutErrorProps) {
    super({
      message: 'Timeout',
      ...props,
      extraData: {
        timeout
      }
    });

    this.timeout = timeout;
  }
}
